<template>
	<div>
		<div class="header-project">
			<div class="header-name bg-customer-gradient">
				<b-container class="container-project">
					<h1 class="text-white py-3 text-uppercase">¡Hola {{user.name}}!</h1>
				</b-container>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Header",
	data() {
		return {
			user: this.$auth.user(),
		}
	},
	mounted() {

	},
	methods: {
		logout(){
			this.$auth.logout({
				redirect: '/login',
				success: function (msg) {
					console.error("LOGIN:",msg);
				},
			});
		}
	},
};
</script>
<style>
	.navbar {
		background: rgba(183, 183, 183, 0.66);
	}
	.logo{
		width: 150px;
		margin-left: 45px;
	}
	@media (min-width:992px){
		.header-title{
			padding-top:125px;
		}
	}
	@media (max-width:992px){
		.header-title{
			padding-top:25px
		}
	}
</style>
